// eslint-disable-next-line import/prefer-default-export
export const PREFIX_CARE_MODULE = {
  BLENDED_TUTOR: 'Blended Tutor',
  BLENDED_VHS: 'Blended VHS',
  DUO: 'Duo',
  TUTOR: 'TUTOR',
  IELTS: 'IELTS',
  STATION: 'STAION',
};
export const getModuleCare = function (item) {
  if (item.type_blended) {
    switch (item.type_blended) {
      case 1:
        return 'BLENDED_DUO';
      case 2:
        return 'BLENDED_TUTOR';
      case 3:
        return 'BLENDED_IELTS';
      case 4:
        return 'BLENDED_STATION';
      default:
        return '';
    }
  }

  if (item.type_curriculum) {
    switch (item.type_curriculum) {
      case 'online':
        return 'TUTOR';
      case 'duo':
        return 'DUO';
      case 'ielts':
        return 'IELTS';
      case 'ieltsy':
        return 'STATION';
      default:
        return '';
    }
  }
  return '';
};

export const moduleCareColor = {
  BLENDED_TUTOR: '#27C100',
  BLENDED_VHS: '',
  DUO: '#c18000',
  TUTOR: '#AB47BC',
  IELTS: '',
  STATION: '',
};
export const LIST_STATUS_SUPPORT = [
  {
    id: 1, name: 'Mới', color: '#03A9F4',
  },
  {

    id: 2, name: 'Đang xử lý', color: '#FF6D00',
  },
  {

    id: 3, name: 'Chờ duyệt', color: '#FFC400',
  },
  {

    id: 4, name: 'Tạm dừng', color: '#A0A0A0',
  },
  {
    id: 5, name: 'Hoàn thành', color: '#5AC725',
  },
  {
    id: 6, name: 'Hủy', color: '#FF3D00',
  },
];

const ORDER_RECEIPT_STATUS = {
  INIT: 'init', // Chờ xử lí
  IN_PROGRESS: 'in_progress', // Chờ thanh toán
  FINAL_SUCCESS: 'final_success', // Thành công
  FINAL_RETURN: 'final_return', // Hoàn
  FINAL_CANCEL: 'final_cancel', // Hủy
  FINAL_FAILED: 'final_failed', // Thất bại
};
export const ORDER_RECEIPT_STATUS_MAP = [
  {
    value: ORDER_RECEIPT_STATUS.INIT,
    text: 'Chờ xử lý',
    styleClass: 'primary',
  },
  {
    value: ORDER_RECEIPT_STATUS.IN_PROGRESS,
    text: 'Chờ thanh toán',
    styleClass: 'primary',
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_SUCCESS,
    text: 'Thành công',
    styleClass: 'success',
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_RETURN,
    text: 'Hoàn',
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_CANCEL,
    text: 'Hủy',
  },
  {
    value: ORDER_RECEIPT_STATUS.FINAL_FAILED,
    text: 'Thất bại',
  },
];
export const STUDENT_DETAIL_BLENDED_TAB_INDEX = {
  PERIODICALLY_CARE: 0,
  TUTOR_STUDY_RESULT: 1,
  DUO_STUDY_RESULT: 2,
  LOG: 3,
  TICKET: 4,
  TASK: 5,
  NOTE: 6,
  ACTIVITY: 7,
};
